import React, { Component } from "react";
import { Formik, Field, Form, ErrorMessage, 
  // FieldArray
 } from "formik";
import * as Yup from "yup";
import * as moment from "moment";
import {
  success,
  warning,
  successNotification,
  error,
  errorNotification,
  warningNotification,
} from "../notification/notifications";
import makeAnimated from "react-select/animated";
import { StudentAssessmentService } from "../../services/studentAssessment.service";
import AdminHeader from "../dashboardheader/adminheader";
import Finxfooter from "../../containers/finxfooter/finxfooter";
import { LoginService } from "../../services/login.service";
import { RegionManagementService } from "../../services/regionManagement.service";
import { RegisterUserService } from "../../services/registration.service";
import { PopUpPortal } from "../../containers/popups/PopUpPortal";
import AdminEditQuestionnaire from "./adminEditQuestionnaire";
import { Multiselect } from "multiselect-react-dropdown";

class adminEditJob extends Component {
  constructor(props) {
    super(props);
    console.log("Propss createJob", props);
    this.multiselectRef = React.createRef();
    this.multiselectRefCity = React.createRef();
    this.multiselectRefPrimarySkill = React.createRef();
    if (localStorage.getItem("login") !== null) {
      this.state = {
        selectedFilterValue: [],
        selectedValue: [],
        selectedCityValue: [],
        selectedSuburbValue: [],
        selectedStateList: [],
        selectedCityList: [],
        selectedSuburbList: [],
        stateId: "",
        dateExpiry: "",

        selectedPrimarySkillList: [],
        selectedSecondarySkillList: [],
        selectedPrimarySkillValue: [],
        selectedSecondarySkillValue: [],
        // skill: "",

        // skill1: "",
        // location: "",
        // fromyear: "",
        // frommonth: "",
        // fromday: "",
        // toyear: "",
        // tomonth: "",
        // today: "",
        // city: "",

        // cityLabel: "",
        // suburbLabel: "",
        // statee: "",

        // cityId: "",

        // suburb: "",

        roleList: [],
        suburbList: [],
        cityList: [],
        stateList: [],
        skillList: [],
        secondarySkillList: [],
        // totalScore: 0,
        // eligibleScore: "",
        corporateList: [],
        jobCategoryList: [],
        listOfYear: [],
        listOfMonth: [],
        listOfDay: [],
        document: [],
        answerType: [],
        showOptions: "none",
        correctAnswer: [],
        returnChild: true,
        submit: false,
        // isActive: "",
        loading: false,
        listOfExpiryYear: [],
        listOfExpiryMonth: [],
        listOfExpiryDay: [],
        // jobId: "",

        // jobTitle: "",

        // jobDesc: "",

        // corporate: "",
        // corporateName: "",
        // corpId: "",
        // pincode: "",
        // experience: "",
        // ctc: "",
        // arn: "",
        // benefit: "",
        // expiryDate: "",
        // entryDate: "",

        // roleid: "",

        // jobType: "",

        // expiryDay: "",

        // expirymonth: "",
        // expiryYear: "",

        questionnaireData: [],

        finalStateCitySurb: [],
        jobDetails: {},
        isDisabled: false,
        isEdit: false,

      
        totalExperienceList:[]
      };
    } else {
      window.location.href = "/";
    }
  }
  reset = () => {
    this.props.history.push("/adminJob");
  };

  /* New MultiSelect Function */
  onPrimarySelect = (selectedList, selectedItem) => {
    let keySkillId = [];
    let selectedPrimaryList = [];
    for (let i = 0; i < selectedList.length; i++) {
      keySkillId.push(selectedList[i].keySkillId);
      selectedPrimaryList.push(selectedList[i]);
    }
    this.setState({
      selectedPrimarySkillList: keySkillId,
      selectedPrimarySkillValue: selectedPrimaryList,
    });
    StudentAssessmentService.getSkill(keySkillId, (res) => {
      this.setState({
        secondarySkillList: res.responseListObject
          ? res.responseListObject
          : [],
      });
    });
  };
  onPrimaryRemove = (selectedList, selectedItem) => {
    let stageName = [];
    let selectedPrimaryList = [];
    for (let i = 0; i < selectedList.length; i++) {
      stageName.push(selectedList[i].keySkillId);
      selectedPrimaryList.push(selectedList[i]);
    }
    let secondaryList = [];
    let selectedSecondaryList = [];
    for (let i = 0; i < this.state.secondarySkillList.length; i++) {
      if (
        this.state.secondarySkillList[i].parKeyskillId !==
        selectedItem.keySkillId
      ) {
        secondaryList.push(this.state.secondarySkillList[i]);
        selectedSecondaryList.push(this.state.secondarySkillList[i].keySkillId);
      }
    }
    this.setState({
      selectedPrimarySkillList: stageName,
      selectedPrimarySkillValue: selectedPrimaryList,
      secondarySkillList: secondaryList,
      selectedSecondarySkillList: selectedSecondaryList,
      // selectedSecondarySkillValue: secondaryList,
    });
    this.multiselectRefPrimarySkill.current.resetSelectedValues();
  };
  onSecondarySelect = (selectedList, selectedItem) => {
    let stageName = [];
    let selectedSecondaryList = [];
    for (let i = 0; i < selectedList.length; i++) {
      stageName.push(selectedList[i].keySkillId);
      selectedSecondaryList.push(selectedList[i]);
    }
    this.setState({
      selectedSecondarySkillList: stageName,
      selectedSecondarySkillValue: selectedSecondaryList,
    });
  };
  onSecondaryRemove = (selectedList, selectedItem) => {
    let stageName = [];
    let selectedSecondaryList = [];
    for (let i = 0; i < selectedList.length; i++) {
      stageName.push(selectedList[i].keySkillId);
      selectedSecondaryList.push(selectedList[i]);
    }
    this.setState({
      selectedSecondarySkillList: stageName,
      selectedSecondarySkillValue: selectedSecondaryList,
    });
  };
  onStateSelect = (selectedList, selectedItem) => {
    let stageName = [];
    let listStateSelected = [];
    //  //debugger
    //  for (let l = 0; l < this.state.finalStateCitySurb.length; l++) {
    //   if(this.state.finalStateCitySurb[l].stateId !== selectedItem.stateId ){
    for (let i = 0; i < selectedList.length; i++) {
      stageName.push(selectedList[i].stateId);
      listStateSelected.push(selectedList[i]);
    }

    this.setState({
      selectedStateList: stageName,
      selectedValue: listStateSelected,
    });
    if (selectedList !== undefined) {
      RegionManagementService.getMultiCity(stageName, (res) => {
        let cityList=res.responseListObject;
        cityList.forEach((item) => {
          item.cityName = item.cityName
            .split(' ')
            .map((word) => {
              return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            })
            .join(' ');
        });
     
        this.setState({
          cityList
        });
        // this.setState({
        //   cityList: res.responseListObject,
        // });
      });
    }
    this.multiselectRef.current.resetSelectedValues();
    this.setState({
      selectedCityList:[],
      selectedCityValue:[],
      finalStateCitySurb:[]
    })
  };
  onStateRemove = (selectedList, selectedItem) => {
    // debugger;
    let cityList = [];
    let s1 = [];
    let c1 = [];
    let stageName = [];
    for (let i = 0; i < selectedList.length; i++) {
      stageName.push(selectedList[i].stateId);
      s1.push(selectedList[i]);
    }
    this.setState({
      selectedStateList: stageName,
      selectedValue: s1,
    });
    // cityList = this.state.selectedCityValue;
    for (let i = 0; i < this.state.cityList.length; i++) {
      // console.log("---", this.state.cityList[i]);
      if (this.state.cityList[i].state.stateId !== selectedItem.stateId) {
        cityList.push(this.state.cityList[i]);
        c1.push(this.state.cityList[i].cityId);
      }
    }
    // console.log("before set :: "+this.state.selectedCityValue);
    this.setState({
      cityList: cityList,
      // selectedCityList: c1,
      selectedCityList: [],
      selectedCityValue: [],
    });
    this.multiselectRef.current.resetSelectedValues();
    if (this.multiselectRefCity.current.resetSelectedValues()) {
      this.setState({
        suburbList: [],
      });
    }
    console.log("after set :: " + this.state.selectedCityValue);
    //debugger
    // if (this.props.location.state !== undefined) {
    //   let stateTemp = [
    //     ...this.props.location.state.sendJobDetails.jobLocationMap,
    //   ];
    //   stateTemp.map((item, index) => {
    //     // //debugger
    //     if (item.stateId === selectedItem.stateId) {
    //       item.suburbIsActive = 0;
    //       item.cityIsActive = 0;
    //       item.stateIsActive = 0;
    //     }
    //   });
    //   let uniqueObjArray = [
    //     ...new Map(stateTemp.map((item) => [item["suburbId"], item])).values(),
    //   ];
    //   this.setState({ finalStateCitySurb: uniqueObjArray }, () => {
    //     ////debugger
    //     console.log("test ofr state", this.state.finalStateCitySurb);
    //   });
    // } else {
    let stateTemp = [...this.state.finalStateCitySurb];
    stateTemp.map((item, index) => {
      // //debugger
      if (item.stateId === selectedItem.stateId) {
        item.suburbIsActive = 0;
        item.cityIsActive = 0;
        item.stateIsActive = 0;
      }
    });
    // let uniqueObjArray = [
    //   ...new Map(stateTemp.map((item) => [item["suburbId"], item])).values(),
    // ];
    // this.setState({ finalStateCitySurb: uniqueObjArray }, () => {
    //   ////debugger
    //   // console.log("test ofr state", this.state.finalStateCitySurb);
    // });
    this.setState({
      finalStateCitySurb:[]
    })
    // }
  };
  onCitySelect = (selectedList, selectedItem) => {
    this.multiselectRefCity.current.resetSelectedValues();
    //debugger
    let stageName = [];
    let citySelected = [];
    let cityObj = {};
    let newCityObj = [];
    console.log("selectedList", selectedList);
    console.log("selectedItem", selectedItem);

    // if (this.props.location.state !== undefined) {
    //   let cityTemp = [
    //     ...this.props.location.state.sendJobDetails.jobLocationMap,
    //   ];
    //   cityTemp.map((item, index) => {
    //     // //debugger
    //     if (item.cityId === selectedItem.cityId) {
    //       item.suburbIsActive = 1;
    //       item.cityIsActive = 1;
    //     }
    //   });
    //   for (let i = 0; i < selectedList.length; i++) {
    //     stageName.push(selectedList[i].cityId);
    //     cityObj = {
    //       stateId: selectedList[i].state.stateId,
    //       cityId: selectedList[i].cityId,
    //       suburbId: 0,
    //       locMapid: 0,
    //     };
    //     newCityObj.push(cityObj);
    //   }
    //   // this.setState({ selectedCityList: newCityObj });
    //   this.setState({ finalStateCitySurb: newCityObj });
    //   // let uniqueObjArray = [
    //   //   ...new Map(cityTemp.map((item) => [item["suburbId"], item])).values(),
    //   // ];
    //   // this.setState({ finalStateCitySurb: uniqueObjArray });
    // } else {

    for (let i = 0; i < selectedList.length; i++) {
      stageName.push(selectedList[i].cityId);
      citySelected.push(selectedList[i]);
      cityObj = {
        stateId: selectedList[i].state.stateId,
        cityId: selectedList[i].cityId,
        suburbId: 0,
        locMapid: 0,
      };
      newCityObj.push(cityObj);
    }
    //!old
    // this.setState({ selectedCityList: newCityObj });
    this.setState({ finalStateCitySurb: newCityObj });
    //! new
    this.setState({ selectedCityList: stageName });
    this.setState({ selectedCityValue: citySelected });
    // }

    if (selectedList !== undefined) {
      RegionManagementService.getMultiSuburb(stageName, (res) => {
        this.setState({
          suburbList: res.responseListObject ? res.responseListObject : [],
        });
      });
    }
    this.multiselectRefCity.current.resetSelectedValues();
    this.setState({
      selectedSuburbList:[],
      selectedSuburbValue:[]
    })
  };
  onCityRemove = (selectedList, selectedItem) => {
    let cityId = [];
    let cityObj = [];
    for (let i = 0; i < selectedList.length; i++) {
      cityId.push(selectedList[i].cityId);
      cityObj.push(selectedList[i]);
    }
    this.setState({
      selectedCityList: cityId,
      selectedCityValue: cityObj,
    });
    this.multiselectRefCity.current.resetSelectedValues();
    let suburblist = [];

    for (let i = 0; i < this.state.suburbList.length; i++) {
      if (this.state.suburbList[i].cityId !== selectedItem.cityId) {
        suburblist.push(this.state.suburbList[i]);
      }
    }
    this.setState({
      suburbList: suburblist,
      // selectedSuburbValue: suburblist,
    });
      // this.setState({
      //   suburbList: suburblist,
      //   selectedSuburbValue: suburblist,
      // });

    //debugger
    // if (this.props.location.state !== undefined) {
    //   let cityTemp = [
    //     ...this.props.location.state.sendJobDetails.jobLocationMap,
    //   ];
    //   cityTemp.map((item, index) => {
    //     if (item.cityId === selectedItem.cityId) {
    //       // item.cityIsActive = 0;
    //       // item.suburbIsActive = 0;
    //     }
    //   });
    //   let uniqueObjArray = [
    //     ...new Map(cityTemp.map((item) => [item["suburbId"], item])).values(),
    //   ];
    //   this.setState({ finalStateCitySurb: uniqueObjArray }, () => {
    //     ////debugger
    //     console.log("test ofr city", this.state.finalStateCitySurb);
    //   });
    //   console.log(this.state.finalStateCitySurb);
    // } else {
    // console.log("fina", this.state.finalStateCitySurb);
    // console.log("selectedItem", selectedItem);

    let cityTemp = [...this.state.finalStateCitySurb];
    // console.log("cityTemp", cityTemp);

    // cityTemp.map((item, index) => {
    //   if (item.cityId === selectedItem.cityId) {
    //     item.cityIsActive = 0;
    //     item.suburbIsActive = 0;
    //   }
    // });
    // let uniqueObjArray = [
    //   ...new Map(cityTemp.map((item) => [item["suburbId"], item])).values(),
    // ];
    // console.log("uniqueObjArray", uniqueObjArray);

    cityTemp.map((val, index) => {
      if (selectedItem.cityId === val.cityId) {
        cityTemp.splice(index, 1);
      }
    });
    this.setState({ finalStateCitySurb: cityTemp });
    // this.setState({ finalStateCitySurb: uniqueObjArray }, () => {
    //   ////debugger
    //   console.log("test ofr city", this.state.finalStateCitySurb);
    // });
    // console.log(this.state.finalStateCitySurb);
    // }
  };
  onSuburbSelect = (selectedList, selectedItem) => {
    let suburbId = [];
    let suburbObj = [];
    console.log("selectedList", selectedList);
    console.log("selectedItem", selectedItem);

    for (let i = 0; i < selectedList.length; i++) {
      suburbId.push(selectedList[i].suburbId);
      suburbObj.push(selectedList[i]);
    }

    this.setState({
      selectedSuburbList: suburbId,
      selectedSuburbValue: suburbObj,
    });

    // let newLocid = "";
    // let flagoc = false;
    let finalList = [];
    let finalObj = {};
    // let storeit = [];
    // debugger;
    // if (this.props.location.state !== undefined) {
    //   let LocTemp = [
    //     ...this.props.location.state.sendJobDetails.jobLocationMap,
    //   ];
    //   LocTemp.map((item, index) => {
    //     newLocid = item.locMapid;
    //     flagoc = true;
    //     // if (item.suburbId == selectedItem.suburb) {
    //     if (item.suburbId == selectedItem.suburbId) {
    //       item.suburbIsActive = 1;
    //       item.cityIsActive = 1;
    //       item.stateIsActive = 1;
    //     }
    //     storeit = [...LocTemp];
    //   });

    //   // debugger;
    //   for (let i = 0; i < selectedList.length; i++) {
    //     // let obj = storeit.find((o) => o.suburbId === selectedList[i].suburb);
    //     let obj = storeit.find((o) => o.suburbId === selectedList[i].suburbId);
    //     console.log("obj", obj);

    //     if (obj === undefined) {
    //       storeit.push({
    //         stateId: selectedList[i].stateId,
    //         cityId: selectedList[i].cityId,
    //         stateIsActive: 1,
    //         cityIsActive: 1,
    //         suburbIsActive: 1,
    //         // suburbId: selectedList[i].suburb,
    //         suburbId: selectedList[i].suburbId,
    //         locMapid: 0,
    //       });
    //     }
    //   }

    //   console.log("finalStateCitySuburb", this.state.finalStateCitySurb);

    //   let uniqueObjArray = [
    //     ...new Map(storeit.map((item) => [item["suburbId"], item])).values(),
    //   ];
    //   this.setState({
    //     finalStateCitySurb: uniqueObjArray,
    //   });
    // } else {
    // for (let i = 0; i < selectedList.length; i++) {
    //   for (let j = 0; j < this.state.selectedCityList.length; j++) {
    //     if (
    //       selectedList[i].cityId === this.state.selectedCityList[j].cityId
    //     ) {
    //       finalObj = {
    //         stateId: this.state.selectedCityList[j].stateId,
    //         cityId: this.state.selectedCityList[j].cityId,
    //         suburbId: selectedList[i].suburbId,
    //         locMapid: 0,
    //         // stateIsActive: 1,
    //         // cityIsActive: 1,
    //         // suburbIsActive: 1,
    //       };
    //       finalList.push(finalObj);
    //     }
    //   }
    // }

    //     let cityCount = 0;
    //   let tempCount = 0;
    //   this.state.finalStateCitySurb.map((val,index) => {
    //     if(selectedItem.cityId === val.cityId) {
    //       cityCount = cityCount + 1;
    //     }
    //  });
    //  let stateId = 0;
    //  selectedList.map((val,index) => {
    //     if(cityCount === 1 && selectedItem.cityId === val.cityId) {
    //       this.state.selectedCityValue.map((cityVal,index) => {
    //         if(cityVal.cityId === selectedItem.cityId) {
    //           stateId =  cityVal.state.stateId;
    //         }
    //       });
    //       finalObj = {
    //         stateId: stateId,
    //         cityId: selectedItem.cityId,
    //         suburbId: selectedItem.suburbId,
    //         locMapid: 0,
    //         // stateIsActive: 1,
    //         // cityIsActive: 1,
    //         // suburbIsActive: 1,
    //       };
    //       finalList.push(finalObj);
    //    } else {
    //      if(selectedList[index].suburbId !== val.suburbId) {
    //       finalObj = {
    //         stateId: this.state.finalStateCitySurb[index].stateId,
    //         cityId: selectedItem.cityId,
    //         suburbId: selectedItem.suburbId,
    //         locMapid: 0,
    //         // stateIsActive: 1,
    //         // cityIsActive: 1,
    //         // suburbIsActive: 1,
    //       };
    //       finalList.push(finalObj);
    //      }
    //    }
    //   });

    let stateId = 0;
    finalList = this.state.finalStateCitySurb;

    this.state.selectedCityValue.map((cityVal, index) => {
      if (cityVal.cityId === selectedItem.cityId) {
        stateId = cityVal.state.stateId;
      }
    });
    finalList.map((val, index) => {
      if (val.cityId === selectedItem.cityId && val.suburbId === 0) {
        finalList[index].suburbId = selectedItem.suburbId;
      } else {
        if (
          val.cityId === selectedItem.cityId &&
          val.suburbId !== selectedItem.suburbId
        ) {
          finalObj = {
            stateId: stateId,
            cityId: selectedItem.cityId,
            suburbId: selectedItem.suburbId,
            locMapid: 0,
          };
          finalList.push(finalObj);
        }
      }
    });

    // for (let i = 0; i < selectedList.length; i++) {
    //   for (let j = 0; j < this.state.finalStateCitySurb.length; j++) {
    //     if (
    //       selectedList[i].cityId === this.state.finalStateCitySurb[j].cityId
    //     ) {
    //       finalObj = {
    //         stateId: this.state.finalStateCitySurb[j].stateId,
    //         cityId: this.state.finalStateCitySurb[j].cityId,
    //         suburbId: selectedList[i].suburbId,
    //         locMapid: 0,
    //         // stateIsActive: 1,
    //         // cityIsActive: 1,
    //         // suburbIsActive: 1,
    //       };
    //       finalList.push(finalObj);
    //     }
    //   }
    // }
    console.log("finallist", finalList);

    // let uniqueObjArray = [
    //   ...new Map(finalList.map((item) => [item["suburbId"], item])).values(),
    // ];
    // this.setState({ finalStateCitySurb: uniqueObjArray });
    let uniqueObjArray1 = finalList.filter((v,i,a)=>a.findIndex(v2 => JSON.stringify(v2)===JSON.stringify(v))===i)
      console.log('uniqueObjArray1',uniqueObjArray1);
    // this.setState({ finalStateCitySurb: finalList });
    this.setState({ finalStateCitySurb: uniqueObjArray1 });
    // }
  };
  onSuburbRemove = (selectedList, selectedItem) => {
    let suburbId = [];
    let suburbObj = [];
    console.log("selectedList", selectedList);
    console.log("selectedItem", selectedItem);

    for (let i = 0; i < selectedList.length; i++) {
      suburbId.push(selectedList[i].suburbId?selectedList[i].suburbId:selectedList[i].suburb);
      suburbObj.push(selectedList[i]);
    }

    this.setState({
      selectedSuburbList: suburbId,
      selectedSuburbValue: suburbObj,
    });
    ////debugger
    // let newLocid =""
    // let flagoc = false
    // let LocTemp = [...this.props.location.state.sendJobDetails.jobLocationMap]
    // LocTemp.map((item,index)=>{
    //   //debugger
    //   if(item.suburbId == selectedItem.suburb){
    //   newLocid = item.locMapid
    //   flagoc = true
    //   }
    //   console.log(newLocid);

    // })

    // for (let i = 0; i < this.state.finalStateCitySurb.length; i++) {
    //   const index = this.state.finalStateCitySurb.findIndex(object => {
    //     return object.suburbId === selectedItem.suburb;
    //   });
    //   if (index !== -1) {
    //     this.state.finalStateCitySurb[index].suburbIsActive = 0;
    //   }

    // }
    let suburbTemp = [...this.state.finalStateCitySurb];
    // suburbTemp.map((item, index) => {
    //   if (item.suburbId === selectedItem.suburbId) {
    //   // if (item.suburbId === selectedItem.suburb) {
    //     item.suburbIsActive = 0;
    //   }
    // });

    let cityCount = 0;
    // let tempCount = 0;
    suburbTemp.map((val, index) => {
      if (selectedItem.cityId === val.cityId) {
        cityCount = cityCount + 1;
      }
    });
    console.log("suburbTemp", suburbTemp);

    suburbTemp.map((val, index) => {
      if (
        selectedItem.suburb === val.suburbId ||
        selectedItem.suburbId === val.suburbId
      ) {
        if (cityCount === 1) {
          suburbTemp[index].suburbId = 0;
        } else {
          suburbTemp.splice(index, 1);
        }
      }
    });
    console.log("aaa", suburbTemp);

    // let uniqueObjArray = [
    //   ...new Map(suburbTemp.map((item) => [item["suburbId"], item])).values(),
    // ];
    // console.log("uniq", uniqueObjArray);

    this.setState({ finalStateCitySurb: suburbTemp });
    // this.setState({ finalStateCitySurb: uniqueObjArray }, () => {
    ////debugger
    // console.log("test", this.state.finalStateCitySurb);
    // });

    // console.log(this.state.finalStateCitySurb);

    //  this.state.finalStateCitySurb.find(x => x.suburbId === selectedItem.suburb)["suburbIsActive"] = 0
    // this.state.finalStateCitySurb.map((item,index)=>{
    //   if(item.suburbId===selectedItem.suburb){
    //     item.suburbIsActive=0
    //   }else{
    //     item.suburbIsActive=1
    //   }
    //   console.log("rem",selectedItem);
    // });
    // this.setState({ selectedSuburbList: stageName });
  };

  /* New MultiSelect Ends*/

  handleCallback = (childData, totalScore) => {
    this.setState({ questionnaireData: childData });
    this.setState({ totalScore: totalScore });
  };

  animatedComponents = makeAnimated();

  componentDidMount() {
    RegisterUserService.getTotalExperienceList((res) => {
    
      if(res.status==="success"){
      this.setState({
        totalExperienceList: res.responseListObject,
      });
    }
    });
    LoginService.TokenUser((res) => {
      localStorage.setItem("jwt-token", res.responseObject);
    });
    this.initailizedDateDetails();
    this.fetchJobDetailsByJobID();
    RegionManagementService.getState("countryId=1", (res) => {
      let stateList=res.responseListObject;
      stateList.forEach((item) => {
        item.stateName = item.stateName
          .split(' ')
          .map((word) => {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          })
          .join(' ');
      });
      this.setState({
        stateList
      });
      // this.setState({
      //   stateList: res.responseListObject,
      // });
    });
    StudentAssessmentService.getJobRole("roleid=0", (res) => {
      this.setState({
        roleList: res.responseListObject,
      });
    });
    StudentAssessmentService.getSkill([0], (res) => {
      this.setState({
        skillList: res.responseListObject,
      });
    });
    StudentAssessmentService.getCorporateType(
      "corpTypeId=0&corpId=0",
      (res) => {
        this.setState({
          corporateList: res.responseListObject,
        });
      }
    );
    StudentAssessmentService.getJobCategory(res => {
      this.setState({
        jobCategoryList: res.data.responseListObject,
      });
    }
  );
    console.log("finalStateCitySurb", this.state.finalStateCitySurb);

    // //debugger

    // --------------------------------testing-------------------------------------------------------
    // if (
    //   this.props.location.state !== undefined &&
    //   (this.props.location.state.sendJobDetails !== undefined ||
    //     this.props.location.state.sendJobDetails !== "")
    // ) {
    //   if (
    //     this.props.location.state.sendJobDetails.jobLocationMap !== [] &&
    //     this.props.location.state.sendJobDetails.jobLocationMap.length > 0
    //   ) {
    //     let stateList = [];
    //     let stateData = {};
    //     let cityList = [];
    //     let cityData = {};
    //     let suburbList = [];
    //     let suburbData = {};
    //     let stageName = [];
    //     let stateIds = [];
    //     let cityObj = {};
    //     let newCityObj = [];
    //     let unique = [];
    //     let unique1 = [];
    //     let unique2 = [];
    //     let cityIds = [];

    //     for (
    //       let i = 0;
    //       i < this.props.location.state.sendJobDetails.jobLocationMap.length;
    //       i++
    //     ) {
    //       for (
    //         let j = 0;
    //         j <
    //         this.props.location.state.sendJobDetails.jobLocationMap[i].state
    //           .length;
    //         j++
    //       ) {
    //         // //debugger
    //         stateData = {
    //           stateId: this.props.location.state.sendJobDetails.jobLocationMap[
    //             i
    //           ].state[j].stateId,
    //           stateName: this.props.location.state.sendJobDetails
    //             .jobLocationMap[i].state[j].stateName,
    //           stateIsActive: this.props.location.state.sendJobDetails
    //             .jobLocationMap[i].stateIsActive,
    //         };

    //         stateIds.push(
    //           this.props.location.state.sendJobDetails.jobLocationMap[i].state[
    //             j
    //           ].stateId
    //         );
    //       }
    //       stateList.push(stateData);

    //       unique = Array.from(new Set(stateList.map(JSON.stringify))).map(
    //         JSON.parse
    //       );

    //       for (
    //         let k = 0;
    //         k <
    //         this.props.location.state.sendJobDetails.jobLocationMap[i].city
    //           .length;
    //         k++
    //       ) {
    //         cityData = {
    //           cityId: this.props.location.state.sendJobDetails.jobLocationMap[i]
    //             .city[k].cityId,
    //           cityName: this.props.location.state.sendJobDetails.jobLocationMap[
    //             i
    //           ].city[k].cityName,
    //           state: this.props.location.state.sendJobDetails.jobLocationMap[i]
    //             .city[k].state,
    //           cityIsActive: this.props.location.state.sendJobDetails
    //             .jobLocationMap[i].cityIsActive,
    //           stateIsActive: this.props.location.state.sendJobDetails
    //             .jobLocationMap[i].stateIsActive,
    //         };
    //         cityObj = {
    //           state: this.props.location.state.sendJobDetails.jobLocationMap[i]
    //             .city[k].state,
    //           stateId: this.props.location.state.sendJobDetails.jobLocationMap[
    //             i
    //           ].city[k].state.stateId,
    //           cityId: this.props.location.state.sendJobDetails.jobLocationMap[i]
    //             .city[k].cityId,
    //         };
    //         cityIds.push(
    //           this.props.location.state.sendJobDetails.jobLocationMap[i].cityId
    //         );
    //       }
    //       cityList.push(cityData);
    //       newCityObj.push(cityObj);

    //       unique1 = Array.from(new Set(cityList.map(JSON.stringify))).map(
    //         JSON.parse
    //       );
    //       console.log("unique1:: ", unique1);
    //       for (
    //         let l = 0;
    //         l <
    //         this.props.location.state.sendJobDetails.jobLocationMap[i].suburb
    //           .length;
    //         l++
    //       ) {
    //         suburbData = {
    //           suburb: this.props.location.state.sendJobDetails.jobLocationMap[i]
    //             .suburb[l].suburb,
    //           stateId: this.props.location.state.sendJobDetails.jobLocationMap[
    //             i
    //           ].suburb[l].stateId,
    //           suburbName: this.props.location.state.sendJobDetails
    //             .jobLocationMap[i].suburb[l].suburbName,
    //           cityId: this.props.location.state.sendJobDetails.jobLocationMap[i]
    //             .suburb[l].cityId,
    //           suburbIsActive: this.props.location.state.sendJobDetails
    //             .jobLocationMap[i].suburbIsActive,
    //           cityIsActive: this.props.location.state.sendJobDetails
    //             .jobLocationMap[i].cityIsActive,
    //           stateIsActive: this.props.location.state.sendJobDetails
    //             .jobLocationMap[i].stateIsActive,
    //         };
    //         stageName.push(
    //           this.props.location.state.sendJobDetails.jobLocationMap[i].suburb[
    //             l
    //           ].suburb
    //         );
    //       }
    //       suburbList.push(suburbData);

    //       unique2 = Array.from(new Set(suburbList.map(JSON.stringify))).map(
    //         JSON.parse
    //       );

    //       console.log("unique2:: ", unique2);
    //     }
    //     let filterList = unique.filter(function (el) {
    //       return el.stateIsActive === 1;
    //     });
    //     this.setState({ selectedValue: filterList });
    //     this.setState({ selectedStateList: stateIds });
    //     let filterListCity = unique1.filter(function (el) {
    //       return el.cityIsActive === 1 && el.stateIsActive === 1;
    //     });
    //     this.setState({ selectedCityValue: filterListCity });

    //     this.setState({ selectedCityList: newCityObj });
    //     let filterListSuburb = unique2.filter(function (el) {
    //       return (
    //         el.suburbIsActive === 1 &&
    //         el.cityIsActive === 1 &&
    //         el.stateIsActive === 1
    //       );
    //     });

    //     console.log("filterListSuburb", filterListSuburb);
    //     this.setState({ selectedSuburbValue: filterListSuburb });

    //     this.formatData(unique2, unique1, newCityObj, stateIds, cityIds);
    //   }
    // if (
    //   this.props.location.state.sendJobDetails.primeryskillsEntity !== [] &&
    //   this.props.location.state.sendJobDetails.primeryskillsEntity !==
    //     undefined &&
    //   this.props.location.state.sendJobDetails.primeryskillsEntity.length > 0
    // ) {
    //   let primeryskillsList = [];
    //   let uniquePrimeryskillsList = [];
    //   let primarySkillData = {};
    //   let primarySkillName = [];

    //   for (
    //     let i = 0;
    //     i <
    //     this.props.location.state.sendJobDetails.primeryskillsEntity.length;
    //     i++
    //   ) {
    //     primarySkillData = {
    //       skillId: this.props.location.state.sendJobDetails
    //         .primeryskillsEntity[i].keySkillId,
    //       keySkill: this.props.location.state.sendJobDetails
    //         .primeryskillsEntity[i].keySkill,
    //     };
    //     primarySkillName.push(
    //       this.props.location.state.sendJobDetails.primeryskillsEntity[i]
    //         .keySkill
    //     );
    //     primeryskillsList.push(primarySkillData);
    //   }
    //   this.setState({ selectedPrimarySkillList: primarySkillName });
    //   uniquePrimeryskillsList = Array.from(
    //     new Set(primeryskillsList.map(JSON.stringify))
    //   ).map(JSON.parse);
    //   this.setState({ selectedPrimarySkillValue: uniquePrimeryskillsList });
    // }

    // if (
    //   this.props.location.state.sendJobDetails.seconderyskillsEntity !== [] &&
    //   this.props.location.state.sendJobDetails.primeryskillsEntity !==
    //     undefined &&
    //   this.props.location.state.sendJobDetails.seconderyskillsEntity.length >
    //     0
    // ) {
    //   let secondaryskillsList = [];
    //   let uniquesecondaryskillsList = [];
    //   let secondarySkillData = {};
    //   let secondarySkillName = [];

    //   for (
    //     let i = 0;
    //     i <
    //     this.props.location.state.sendJobDetails.seconderyskillsEntity.length;
    //     i++
    //   ) {
    //     secondarySkillData = {
    //       skillId: this.props.location.state.sendJobDetails
    //         .seconderyskillsEntity[i].keySkillId,
    //       keySkill: this.props.location.state.sendJobDetails
    //         .seconderyskillsEntity[i].keySkill,
    //     };
    //     secondarySkillName.push(
    //       this.props.location.state.sendJobDetails.seconderyskillsEntity[i]
    //         .keySkill
    //     );
    //     secondaryskillsList.push(secondarySkillData);
    //   }
    //   this.setState({ selectedSecondarySkillList: secondarySkillName });
    //   uniquesecondaryskillsList = Array.from(
    //     new Set(secondaryskillsList.map(JSON.stringify))
    //   ).map(JSON.parse);
    //   this.setState({
    //     selectedSecondarySkillValue: uniquesecondaryskillsList,
    //   });
    // }
    // }
    // this.fetchPrimary();
    // this.fetchSecond();
  }

  // formatData = (unique2, unique1, newCityObj, stateIds, cityIds) => {
  //   let finalList = [];
  //   let finalObj = {};
  //   let finalListUnique = [];
  //   let uniqueStateIds = [];
  //   let uniqueCityIds = [];
  //   for (let i = 0; i < unique2.length; i++) {
  //     for (let j = 0; j < newCityObj.length; j++) {
  //       for (let u = 0; u < unique1.length; u++) {
  //         if (unique2[i].cityId === newCityObj[j].cityId) {
  //           finalObj = {
  //             stateId: newCityObj[j].state.stateId,
  //             cityId: newCityObj[j].cityId,
  //             suburbId: unique2[i].suburb,
  //             suburbIsActive: unique2[i].suburbIsActive,
  //             cityIsActive: unique1[u].cityIsActive,
  //             stateIsActive: this.props.location.state.sendJobDetails
  //               .jobLocationMap[i].stateIsActive,
  //             locMapid: this.props.location.state.sendJobDetails.jobLocationMap[
  //               i
  //             ].locMapid,
  //           };
  //           finalList.push(finalObj);
  //           finalListUnique = Array.from(
  //             new Set(finalList.map(JSON.stringify))
  //           ).map(JSON.parse);
  //         }
  //       }
  //     }
  //   }
  //   uniqueStateIds = Array.from(new Set(stateIds.map(JSON.stringify))).map(
  //     JSON.parse
  //   );
  //   RegionManagementService.getMultiCity(uniqueStateIds, (res) => {
  //     this.setState({
  //       cityList: res.responseListObject,
  //     });
  //   });
  //   uniqueCityIds = Array.from(new Set(cityIds.map(JSON.stringify))).map(
  //     JSON.parse
  //   );
  //   RegionManagementService.getMultiSuburb(uniqueCityIds, (res) => {
  //     this.setState({
  //       suburbList: res.responseListObject,
  //     });
  //   });
  // };

  fetchJobDetailsByJobID() {
    // if (this.props.location.state.applicantCount > 0) {
    //   this.setState({
    //     isDisabled: true,
    //   });
    // } else {
    //   this.setState({
    //     isEdit: true,
    //   });
    // }
    if (["Active","Inactive"].includes(this.props.location?.state?.jobStatus)) {
      this.setState({
        isDisabled: true,
      });
    }else if(["Draft"].includes(this.props.location?.state?.jobStatus)) {
      this.setState({
        isDisabled: false,
        isEdit: true,
      });
    } else {
      this.setState({
        isEdit: true,
      });
    }

    let jobId = this.props.location.state.jobID;
    let params = "jobId=" + jobId;
    // let params =
    // "jobTitle=&jobId=" +
    // jobId +
    // "&jobDesc=&corporate=&experience=0.00&ctc=0.00&jobType=";
    StudentAssessmentService.getJobDetailsById(params, (res) => {
      console.log("Jobres", res);

      if (res.status === "success") {
        let fromDateString =
          res.responseListObject === null
            ? null
            :res.responseListObject[0].expiryDate ?
             res.responseListObject[0].expiryDate.slice(0, 10):""
        //  let expiryDateString = fromDateString;
        let fromDate = `${parseInt(fromDateString.split("/")[1])}/${parseInt(
          fromDateString.split("/")[0]
        )}/${fromDateString.split("/")[2]}`;

        res.responseListObject[0].expiryDate = fromDate;
        console.log("resss", res.responseListObject[0]);

        // let primarySkill = Object.keys(res.responseListObject[0]).includes(
        //   "primeryskillsEntity"
        // )
        //   ? [res.responseListObject[0].primeryskillsEntity[0].keySkillId]
        //   : [];
        // let secondarySkill = Object.keys(res.responseListObject[0]).includes(
        //   "seconderyskillsEntity"
        // )
        //   ? [res.responseListObject[0].seconderyskillsEntity[0].keySkillId]
        //   : [];
        let primarySkill = [];
        let secondarySkill = [];
        if (
          Object.keys(res.responseListObject[0]).includes("primeryskillsEntity")
        ) {
          for (
            let i = 0;
            i < res.responseListObject[0].primeryskillsEntity.length;
            i++
          ) {
            primarySkill.push(
              res.responseListObject[0].primeryskillsEntity[i].keySkillId
            );
          }
        } else {
          primarySkill = [];
        }
        if (
          Object.keys(res.responseListObject[0]).includes(
            "seconderyskillsEntity"
          )
        ) {
          for (
            let i = 0;
            i < res.responseListObject[0].seconderyskillsEntity.length;
            i++
          ) {
            secondarySkill.push(
              res.responseListObject[0].seconderyskillsEntity[i].keySkillId
            );
          }
        } else {
          secondarySkill = [];
        }
        // let secondarySkill = Object.keys(res.responseListObject[0]).includes(
        //   "seconderyskillsEntity"
        // )
        //   ? [res.responseListObject[0].seconderyskillsEntity[0].keySkillId]
        //   : [];
        let questionnaireDataProp = [];
        let newTotalScore = 0;
        StudentAssessmentService.getQuestionnaire("jobid=" + jobId, (res) => {
          console.log("question data", res);

          if ((res.status = "success" && res.reasonText === null)) {
            questionnaireDataProp = res.responseListObject;
            let ads = res.responseListObject.map((item) => {
              newTotalScore += parseInt(item.score);
            });
            console.log("ads", ads);
            console.log("newTotalScore", newTotalScore);

            this.setState({
              questionnaireData: questionnaireDataProp,
              totalScore: newTotalScore,
            });
          }
        });
        let s1 = [];
        let c1 = [];
        let sb1 = [];
        if (Object.keys(res.responseListObject[0]).includes("jobLocationMap")) {
          for (
            let i = 0;
            i < res.responseListObject[0].jobLocationMap.length;
            i++
          ) {
            //! For State and City Id's Starts
            // console.log(
            //   "jobLocationMap data",
            //   res.responseListObject[0].jobLocationMap[i]
            // );

            // let selectedState1 =
            //   res.responseListObject[0].jobLocationMap[i].state[0].stateId;
            // let selectedCity1 =
            //   res.responseListObject[0].jobLocationMap[i].city[0].cityId;
            // let selectedSuburb1 =
            //   res.responseListObject[0].jobLocationMap[i].suburb.length > 0
            //     ? res.responseListObject[0].jobLocationMap[i].suburb[0].suburbId
            //     : 0;

            // console.log("s12", selectedState1, selectedCity1, selectedSuburb1);
            // let s11 = [];
            // let c11 = [];
            // let sb11 = [];
            // s11.push(
            //   res.responseListObject[0].jobLocationMap[i].state[0].stateId
            // );
            // c11.push(res.responseListObject[0].jobLocationMap[i].city[0].cityId);
            // // if()
            // // sb11.push(res.responseListObject[0].jobLocationMap[i].suburb[0].suburbId)
            // this.setState({
            //   selectedStateList: s11,
            //   selectedCityList: c11,
            //   // selectedSuburbList:sb11,
            // });
            // console.log("000-s11-c11", s11, "--", c11);
            // if (s11 !== undefined) {
            //   console.log("seees11", s11);

            //   RegionManagementService.getMultiCity(s11, (res) => {
            //     this.setState({
            //       cityList: res.responseListObject,
            //     });
            //   });
            // }
            // if (c11 !== undefined) {
            //   console.log("ceeec11", c11);
            //   RegionManagementService.getMultiSuburb(c11, (res) => {
            //     console.log("sbee", res);

            //     this.setState({
            //       suburbList: res.responseListObject
            //         ? res.responseListObject
            //         : [],
            //     });
            //   });
            // }
            //! For State and City Id's Ends

            // s1.push(s12);
            s1.push(res.responseListObject[0].jobLocationMap[i].state[0]);
            c1.push(res.responseListObject[0].jobLocationMap[i].city[0]);
            // sb1.push(
            //   res.responseListObject[0].jobLocationMap[i].suburb.length > 0
            //     ? res.responseListObject[0].jobLocationMap[i].suburb[0]
            //     : []
            // );
            if (res.responseListObject[0].jobLocationMap[i].suburb.length > 0) {
              sb1.push(res.responseListObject[0].jobLocationMap[i].suburb[0]);
            }
          }
        } else {
          s1 = [];
          c1 = [];
          sb1 = [];
        }

        console.log("s1", s1, sb1);

        const uniqueStateIds = [];
        const uniqueState = s1.filter((element) => {
          // console.log("ele", element, element.stateId);

          const isDuplicate = uniqueStateIds.includes(element.stateId);
          // console.log("isDu", isDuplicate);
          if (!isDuplicate) {
            uniqueStateIds.push(element.stateId);
            return true;
          }
          return false;
        });

        const uniqueCityIds = [];
        const uniqueCity = c1.filter((element) => {
          // console.log("ele", element, element.cityId);

          const isDuplicate = uniqueCityIds.includes(element.cityId);
          // console.log("isDu", isDuplicate);
          if (!isDuplicate) {
            uniqueCityIds.push(element.cityId);
            return true;
          }
          return false;
        });
        const uniqueSuburbIds = [];
        const uniqueSuburb = sb1.filter((element) => {
          // console.log("ele", element, element.suburbId);

          const isDuplicate = uniqueSuburbIds.includes(element.suburb);
          // console.log("isDu", isDuplicate);
          if (!isDuplicate) {
            uniqueSuburbIds.push(element.suburb);
            return true;
          }
          return false;
        });
        console.log("uniqueSuburbIds", uniqueSuburbIds);
        console.log("uniqueSuburb", uniqueSuburb);
        console.log("sb1", sb1);

        if (uniqueStateIds !== undefined) {
          console.log("seeeuniqueStateIds", uniqueStateIds);

          RegionManagementService.getMultiCity(uniqueStateIds, (res) => {
            this.setState({
              cityList: res.responseListObject ? res.responseListObject : [],
            });
          });
        }
        if (uniqueCityIds !== undefined) {
          console.log("ceeeuniqueCityIds", uniqueCityIds);
          RegionManagementService.getMultiSuburb(uniqueCityIds, (res) => {
            console.log("sbee", res);

            this.setState({
              suburbList: res.responseListObject ? res.responseListObject : [],
            });
          });
        }
        StudentAssessmentService.getSkill(primarySkill, (res) => {
          this.setState({
            secondarySkillList: res.responseListObject
              ? res.responseListObject
              : [],
          });
        });
        let final = [];
        let jobObject = {};
        res.responseListObject[0].jobLocationMap.map((val, index) => {
          jobObject = {
            stateId: val.stateId,
            cityId: val.cityId,
            suburbId: val.suburbId,
            locMapid: val.locMapid,
          };
          final.push(jobObject);
        });

        this.setState({
          loading: false,
          jobDetails: res.responseListObject[0],
          jobTitle: res.responseListObject[0].jobTitle || "",
          corpId: res.responseListObject[0].corpId || "",
          corporate: res.responseListObject[0].corporate || "",
          roleId: res.responseListObject[0].roleid || "",
          arn: res.responseListObject[0].arn || "",
          jobDesc: res.responseListObject[0].jobDesc || "",
          ctc: res.responseListObject[0].ctc || 0,
          toctc: res.responseListObject[0].toCtc || 0,
          jobCategory: res.responseListObject[0].jobCategoryID === 0 ? "" :res.responseListObject[0].jobCategoryID,
          benefit: res.responseListObject[0].benefit || "",
          jobType: res.responseListObject[0].jobType || "",
          eligibleScore: res.responseListObject[0].eligibleScore || "",
          experience: res.responseListObject[0].experience,
          isActive: res.responseListObject[0].isActive,
          expiryDay : new Date(res.responseListObject[0].expiryDate || "").getDate(),
          expirymonth : new Date(res.responseListObject[0].expiryDate || "").getMonth() + 1,
          expiryYear : new Date(res.responseListObject[0].expiryDate || "").getFullYear(),
          jobLocationMap: res.responseListObject[0].jobLocationMap,
          finalStateCitySurb: final,
          selectedPrimarySkillValue: res.responseListObject[0]
            ? res.responseListObject[0].primeryskillsEntity
            : [],
          selectedSecondarySkillValue: res.responseListObject[0]
            ? res.responseListObject[0].seconderyskillsEntity
            : [],
          selectedPrimarySkillList: primarySkill,
          selectedSecondarySkillList: secondarySkill,

          //! 3
          // selectedValue: s1,
          // selectedCityValue: c1,
          // selectedSuburbValue: sb1,
          selectedValue: uniqueState,
          selectedCityValue: uniqueCity,
          // selectedSuburbValue: sb1,
          selectedSuburbValue: uniqueSuburb,
          selectedStateList: uniqueStateIds,
          selectedCityList: uniqueCityIds,
          selectedSuburbList: uniqueSuburbIds,
        });
        if(this.state.eligibleScore === undefined || this.state.eligibleScore === ""){
        this.setState({
          eligibleScore:this.state.jobDetails.eligibleScore
        })
        }
        console.log(res.responseListObject[0].jobLocationMap[0].state);
        console.log(s1);
      } else {
        this.setState({
          loading: false,
          jobDetails: {},
          selectedPrimarySkillValue: [],
          selectedSecondarySkillValue: [],
          selectedPrimarySkillList: [],
          selectedSecondarySkillList: [],
        });
      }
    });
  }

  initailizedDateDetails() {
    var listOfYear = [];
    var listOfMonth = [];
    var listOfDay = [];
    // var expiryyear = new Date().getFullYear();
    // for (var expi = 0; expi < 10; expi++) {
    //   var expcurrent = expiryyear + expi;
    //   listOfYear.push(expcurrent);
    // }
    var year = 2018;
    for (var i = 1; year + i < 2051; i++) {
      var current = year + i;
      listOfYear.push(current);
    }
    listOfMonth = [
      { key: 1, value: "Jan" },
      { key: 2, value: "Feb" },
      { key: 3, value: "Mar" },
      { key: 4, value: "Apr" },
      { key: 5, value: "May" },
      { key: 6, value: "Jun" },
      { key: 7, value: "Jul" },
      { key: 8, value: "Aug" },
      { key: 9, value: "Sep" },
      { key: 10, value: "Oct" },
      { key: 11, value: "Nov" },
      { key: 12, value: "Dec" },
    ];

    for (var ld = 1; ld <= 31; ld++) {
      listOfDay.push(ld);
    }

    this.setState({ listOfExpiryYear: listOfYear });
    this.setState({ listOfExpiryMonth: listOfMonth });
    this.setState({ listOfExpiryDay: listOfDay });
  }

  getListOfMOnth = (e) => {
    var listOfMonth = [];
    // if (e.target.value === 31) {
    if ([31,"31"].includes(e.target.value)) {
      listOfMonth = [
        { key: 1, value: "Jan" },
        { key: 3, value: "Mar" },
        { key: 5, value: "May" },
        { key: 7, value: "Jul" },
        { key: 8, value: "Aug" },
        { key: 10, value: "Oct" },
        { key: 12, value: "Dec" },
      ];
    // } else if (e.target.value === 30) {
    } else if ([30,"30"].includes(e.target.value)) {
      listOfMonth = [
        { key: 1, value: "Jan" },
        { key: 3, value: "Mar" },
        { key: 4, value: "Apr" },
        { key: 5, value: "May" },
        { key: 6, value: "Jun" },
        { key: 7, value: "Jul" },
        { key: 8, value: "Aug" },
        { key: 9, value: "Sep" },
        { key: 10, value: "Oct" },
        { key: 11, value: "Nov" },
        { key: 12, value: "Dec" },
      ];
    // } else if (e.target.value === 28 || e.target.value === 29) {
    } else if ([28,"28",29,"29"].includes(e.target.value)) {
      listOfMonth = [
        { key: 1, value: "Jan" },
        { key: 2, value: "Feb" },
        { key: 3, value: "Mar" },
        { key: 4, value: "Apr" },
        { key: 5, value: "May" },
        { key: 6, value: "Jun" },
        { key: 7, value: "Jul" },
        { key: 8, value: "Aug" },
        { key: 9, value: "Sep" },
        { key: 10, value: "Oct" },
        { key: 11, value: "Nov" },
        { key: 12, value: "Dec" },
      ];
    } else {
      listOfMonth = [
        { key: 1, value: "Jan" },
        { key: 2, value: "Feb" },
        { key: 3, value: "Mar" },
        { key: 4, value: "Apr" },
        { key: 5, value: "May" },
        { key: 6, value: "Jun" },
        { key: 7, value: "Jul" },
        { key: 8, value: "Aug" },
        { key: 9, value: "Sep" },
        { key: 10, value: "Oct" },
        { key: 11, value: "Nov" },
        { key: 12, value: "Dec" },
      ];
    }
    return listOfMonth;
  };
  isEmptyArray = (array) => {
    return Array.isArray(array) && array.length === 0;
  }
  isValidDate = (dateString) => {
    const date = new Date(dateString);
    return !isNaN(date.getTime()); 
  };
  render() {
    console.log("state", this.state);
    // console.log("props", this.props);

    const { jobDetails } = this.state;
    return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          jobId: jobDetails.jobId,
          corpId: this.state.corpId ,
          // ? this.state.corpId : jobDetails.corpId,
          arn: this.state.arn,
          //  ? this.state.arn : jobDetails.arn,
          entryDate: jobDetails.entryDate,
          roleId: this.state.roleId ,
          // ? this.state.roleId : jobDetails.roleid,
          jobTitle: this.state.jobTitle,
            // ? this.state.jobTitle
            // : jobDetails.jobTitle,
          jobDesc: this.state.jobDesc,
          //  ? this.state.jobDesc : jobDetails.jobDesc,
          corporate: this.state.corporate,
            // ? this.state.corporate
            // : jobDetails.corporate,
          experience: this.state.experience,
          ctc: this.state.ctc,
          //  ? this.state.ctc : jobDetails.ctc,
          toctc: this.state.toctc,
          jobCategory:this.state.jobCategory,
          benefit: this.state.benefit,
          //  ? this.state.benefit : jobDetails.benefit,
          jobType: this.state.jobType,
          //  ? this.state.jobType : jobDetails.jobType,
          eligibleScore: this.state.eligibleScore,
            // ? this.state.eligibleScore
            // : jobDetails.eligibleScore,
          isActive: this.state.isActive,
            // ? this.state.isActive
            // : jobDetails.isActive,
          expiryDay: this.state.expiryDay,
            // ? this.state.expiryDay
            // : new Date(jobDetails.expiryDate).getDate(),
          expirymonth: this.state.expirymonth,
            // ? this.state.expirymonth
            // : new Date(jobDetails.expiryDate).getMonth() + 1,
          expiryYear: this.state.expiryYear,
            // ? this.state.expiryYear
            // : new Date(jobDetails.expiryDate).getFullYear(),
          primeryskills: this.state.selectedPrimarySkillList,
            // ? this.state.selectedPrimarySkillList
            // : [],
          seconderyskills: this.state.selectedSecondarySkillList,
            // ? this.state.selectedSecondarySkillList
            // : [],
          // primeryskills: jobDetails.primeryskillsEntity,
          // seconderyskills: jobDetails.seconderyskillsEntity,
          selectedCityList: this.state.selectedCityList,
          selectedStateList: this.state.selectedStateList,
          selectedSuburbList: this.state.selectedSuburbList,
          document: this.state.document,
          listOfExpiryDay: this.state.listOfExpiryDay,
          listOfExpiryMonth: this.state.listOfExpiryMonth,
          listOfDay: this.state.listOfDay,
          listOfMonth: this.state.listOfMonth,

          corporateList: this.state.corporateList,
          jobCategoryList: this.state.jobCategoryList,
          expiryDate: this.state.expiryDate,

          roleList: this.state.roleList,
          skillList: this.state.skillList,
          secondarySkillList: this.state.secondarySkillList,
          cityList: this.state.cityList,
          location: this.state.location,
          questionnaireData: this.state.questionnaireData,
          dateExpiry: this.state.dateExpiry,
          suburbList: this.state.suburbList,
          city: this.state.city,
          statee: this.state.statee,
          suburb: this.state.suburb,
          totalScore: this.state.totalScore || 0,
         // totalExperienceList:this.state.totalExperienceList?this.state.totalExperienceList:[],
        totalExperienceList:this.state.totalExperienceList||[],
        
        }}
        validationSchema={Yup.object().shape({
          corpId: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" ? true : false,
            then: Yup.string().required("You must specify a Corporate Name"),
            otherwise: Yup.string(),
          }),
          expiryDay: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" || isActive === "2" ? true : false,
            then: Yup.string().required("You must select Day"),
            otherwise: Yup.string(),
          }),
          expiryYear: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" || isActive === "2" ? true : false,
            then: Yup.string().required("You must select Year"),
            otherwise: Yup.string(),
          }),
          expirymonth: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" || isActive === "2" ? true : false,
            then: Yup.string().required("You must select Month"),
            otherwise: Yup.string(),
          }),
          // expiryDay: Yup.string().required("You must select Day"),
          // expiryYear:Yup.string().required("You must select Year"),
          // expirymonth: Yup.string().required("You must select Month"),
          roleId: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" ? true : false,
            then: Yup.string().required("You must specify Job Role"),
            otherwise: Yup.string(),
          }),
          jobTitle: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" ? true : false,
            then: Yup.string()
              .required("You must specify Job Title")
              .max(50, "Job Title not greater than 50")
              // .matches(/^\S([a-zA-Z0-9 ]{1,50})?$/, "Only AlphaNumeric are allowed."),
              .matches(/^[a-zA-Z0-9.]+[a-zA-Z0-9\s.]*$/,
                "First Space is Not Allowed , Only AlphaNumeric, Dot(.), Spaces are allowed."),
            otherwise: Yup.string(),
          }),

          // jobDesc: Yup.string().when("isActive", {
          //   is: (isActive) =>
          //     isActive === "0" || isActive === "1" ? true : false,
          //   then: Yup.string().max(100, "Job Description not greater than 100"),
          //   otherwise: Yup.string(),
          // }),
          ctc: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" ? true : false,
            then: Yup.string()
              // .required("You must specify a CTC")
              .max(12, "From CTC not greater than 12")
              // .matches(/^[1-9]+[0-9.]*$/,"Numbers Only Allowed"),
              // .matches(/^([1-9]{1})*(\.\d{1,11})?$/,"Numbers and Decimals Only Allowed"),
              .matches(/^[0-9]*\.?[0-9]+$/,"Numbers and Decimals Only Allowed"),
            otherwise: Yup.string(),
          }),
          toctc: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" ? true : false,
            then: Yup.string()
              .max(12, "To CTC not greater than 12")
              .matches(/^[0-9]*\.?[0-9]+$/,"Numbers and Decimals Only Allowed"),
            otherwise: Yup.string(),
          }),
          jobCategory: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" ? true : false,
            then: Yup.string()
              .required("You must specify a Job Category"),
            otherwise: Yup.string(),
          }),
          benefit: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" ? true : false,
            then: Yup.string()
              // .required("You must specify a Benefits")
              .max(100, "Benefits not greater than 100"),
            otherwise: Yup.string(),
          }),
          jobType: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" ? true : false,
            then: Yup.string().required("You must specify a jobType"),
            otherwise: Yup.string(),
          }),
          primeryskills: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" || isActive === "2" ? true : false,
            then: Yup.string().required("You must specify a Primary Skills"),
            otherwise: Yup.string(),
          }),
          selectedStateList: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" || isActive === "2" ? true : false,
            then: Yup.string().required("You must specify a State"),
            otherwise: Yup.string(),
          }),
          selectedCityList: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" || isActive === "2" ? true : false,
            then: Yup.string().required("You must specify a City"),
            otherwise: Yup.string(),
          }),
          eligibleScore: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" ? true : false,
            then: Yup.string().required("You must specify a Eligible Score")
            .matches(/^[0-9]*$/,"Numbers Only Allowed"),
            otherwise: Yup.string(),
          }),
          experience: Yup.string().when("isActive", {
            is: (isActive) =>
              isActive === "0" || isActive === "1" ? true : false,
            then: Yup.string().required("You must specify Experience"),
            // .matches(/^[0-9]*\.?[0-9]+$/,"Numbers and Decimals Only Allowed"),
            otherwise: Yup.string(),
          }),
          isActive: Yup.string().required("You must specify a Status"),
   

        })}
        onSubmit={(values, actions) => {
          console.log("values", values);
          console.log('eligible',parseInt(values.eligibleScore));
          console.log('total',parseInt(values.totalScore));
          
          // let ctcRegex = /^[0-9]*\.?[0-9]+$/;
          if([NaN].includes(values.expiryDay)){
            warning("Please Select Expiry Day", warningNotification);
            return;
          }
          if([NaN].includes(values.expirymonth)){
            warning("Please Select Expiry Month", warningNotification);
            return;
          }
          if([NaN].includes(values.expiryYear)){
            warning("Please Select Expiry Year", warningNotification);
            return;
          }
          // if(ctcRegex.test(parseFloat(values.ctc)) === false){
          //   warning("Numbers and Decimals Only Allowed for From CTC",warningNotification);
          //   return;
          // }
          // if(ctcRegex.test(parseFloat(values.toctc)) === false){
          //   warning("Numbers and Decimals Only Allowed for To CTC",warningNotification);
          //   return;
          // }
          // if(parseFloat(values.ctc) > 0 && parseFloat(values.toctc) === 0){
          //   warning("If you have Enter From CTC then you have Enter To CTC also",warningNotification);
          //   return;
          // }
          // if(parseFloat(values.toctc) > 0 && parseFloat(values.ctc) === 0){
          //   warning("If you have Enter To CTC then you have Enter From CTC also",warningNotification);
          //   return;
          // }
          if(parseFloat(values.ctc) > parseFloat(values.toctc)){
            warning('“From CTC” should not be greater than “To CTC”',warningNotification);
            return;
          }          
          if (
            // (this.state.selectedPrimarySkillList === "" ||
              // this.state.selectedPrimarySkillList === []) 
             this.isEmptyArray(this.state.selectedPrimarySkillList) && !this.state.isDisabled
          ) {
            warning("Please Select Primary Skill", warningNotification);
            return;
          }

          if (
            // (this.state.selectedStateList === "" ||
              // this.state.selectedStateList === []) 
             this.isEmptyArray(this.state.selectedStateList) && !this.state.isDisabled
          ) {
            warning("Please Select State", warningNotification);
            return;
          }
          if (
            // (this.state.selectedCityList === "" ||
              // this.state.selectedCityList === []) 
             this.isEmptyArray(this.state.selectedCityList) && !this.state.isDisabled
          ) {
            warning("Please Select City", warningNotification);
            return;
          }
          if (
            parseInt(values.eligibleScore) > parseInt(values.totalScore) &&
            !this.state.isDisabled
          ) {
            warning(
              "Minimum Eligible Score should be less than Total Score",
              warningNotification
            );
            return;
          }

          if (!["2", 2].includes(values.isActive)) {
            if(parseFloat(this.state.ctc) >= 0 && ["",NaN,null,undefined].includes(parseFloat(this.state.toctc))){
              warning('If you have entered “From CTC”  you have to enter “To CTC” as well',warningNotification);
              return;
            }
            if(parseFloat(this.state.toctc) >= 0 && ["",NaN,null,undefined].includes(parseFloat(this.state.ctc))){
              warning('If you have entered “To CTC” you have to enter “From CTC” as well',warningNotification);
              return;
            }
            if (
              this.state.questionnaireData.length <= 0 &&
              !this.state.isDisabled
            ) {
              warning("Please Add Questions pertaining to the job", warningNotification);
              return;
            }
            if (
              ["", 0, null, undefined].includes(values.eligibleScore) &&
              !this.state.isDisabled
            ) {
              warning("Please Enter Minimum Eligible Score", warningNotification);
              return;
            }
            if (
              ["", 0, null, undefined].includes(values.totalScore) &&
              !this.state.isDisabled
            ) {
              warning("Please Enter Total Score", warningNotification);
              return;
            }
            
          }
          this.setState({ loading: false });
          let expiryDate;
          if (values["expiryDay"] !== undefined && values["expiryDay"] !== "") {
            let expDay = "";
            let expMonth = "";
            if (parseInt(values["expiryDay"]) < 10) {
              expDay = "0" + values["expiryDay"];
            } else {
              expDay = values["expiryDay"];
            }
            if (parseInt(values["expirymonth"]) < 10) {
              expMonth = "0" + values["expirymonth"];
            } else {
              expMonth = values["expirymonth"];
            }
            let time = moment().format("LTS").split(" ");
            // this.state.expiryDate =
            //   values["expiryDay"] +
            //   "/" +
            //   values["expirymonth"] +
            //   "/" +
            //   values["expiryYear"] +
            //   " " +
            //   time[0];
            // this.state.expiryDate =
            //   expDay +
              // "/" +
              // expMonth +
              // "/" +
              // values["expiryYear"] +
              // " " +
              // time[0];
              expiryDate =
              expDay +
              "/" +
              expMonth +
              "/" +
              values["expiryYear"] +
              " " +
              time[0];
              // this.setState({
              //   expiryDate
              // })
          }

          let todayDate1 = new Date();
          const fromday = String(todayDate1.getDate()).padStart(2, '0');
          const frommonth = String(todayDate1.getMonth() +1).padStart(2, '0');
          const fromyear = todayDate1.getFullYear();
          const todayDate = `${fromday}/${frommonth}/${fromyear}`;
          const lastModifiedDate = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
          let todayDtConverted = moment(todayDate, "DD.MM.YYYY");
          let expiryDtConverted = moment(expiryDate, "DD.MM.YYYY");
          if (!this.isValidDate(expiryDtConverted)) {
            warning("Invalid Expiry Date",warningNotification);
            return;
          }
          if (expiryDtConverted.diff(todayDtConverted, "days") === 0) {
            warning('“Expiry Date” should not be on or before the “Current Date”',warningNotification);
            return;
          }
          if (expiryDtConverted.diff(todayDtConverted, "days") < 0) {
            warning(
              '“Expiry Date” should not be on or before the “Current Date” ',
              warningNotification
            );
            return;
          }
          
          let data = [
            {
              jobId: values.jobId,
              jobTitle: values.jobTitle,
              jobDesc: values.jobDesc,
              pincode: values.pincode || "",
              // experience: values.experience ? parseFloat(values.experience) : 0,
              experience:values.experience,
              ctc: values.ctc?parseFloat(values.ctc):0,
              toCtc: values.toctc?parseFloat(values.toctc):0,
              jobCategoryID: values.jobCategory || 0,
              benefit: values.benefit,
              expiryDate: expiryDate,
              entryDate: values.entryDate,
              roleid: values.roleId,
              corporate: values.corporate,
              corpId: values.corpId,
              jobType: values.jobType,
              isActive: values.isActive,
              // primeryskills: this.state.selectedPrimarySkillList,
              // seconderyskills: this.state.selectedSecondarySkillList,
              primeryskills: values.primeryskills,
              seconderyskills: values.seconderyskills,
              arn: values.arn ? values.arn : "",
              jobLocationMap: this.state.finalStateCitySurb,
                // ? this.state.finalStateCitySurb
                // : this.state.jobLocationMap,
              eligibleScore: values.eligibleScore,
              lastModifiedBy: localStorage.getItem("userid-Token"),
              lastModifiedDate: lastModifiedDate,
            
            },
          ];
          console.log("payload:::::", data);
          StudentAssessmentService.updateJobDetails(data, (res) => {
            console.log('res',res);
            
            if (res.status === "success") {
              let questionData = [...this.state.questionnaireData];
              //  ////debugger;
              questionData.map((item, index) => {
                item.jobId = res.responseListObject[0].jobId;
              });
              console.log('questionData before',questionData);
              questionData.map((obj) => {
                let optionList = obj?.optionDescEntityList
                optionList.map((option)=>{  
                  if (option?.optionId !== undefined) {
                    delete option?.optionId;
                  }
                  return option;
                })
                return obj;
              });
              console.log('questionData after',questionData);              
              if(questionData.length === 0){
                questionData = 
                [
                  {
                    jobId: res.responseListObject[0].jobId,
                    optionDescEntityList: []
                  }
                ]
              }
              StudentAssessmentService.updateQuestionnaire(
                questionData,
                (res) => {
                  if (res.status === "success") {
                    this.setState({
                      loading: false,
                    });
                    success("Job Updated Successfully", successNotification);
                    this.props.history.push("/adminJob");
                  }
                }
              );
              this.props.history.push("/adminJob");
              // setTimeout(() => {
              //   window.location.reload();
              // }, 5000);
            } else {
              this.setState({ loading: false });
              error(res.reasonText, {
                ...errorNotification,
              });
            }
          });

          actions.setFieldValue((values.loading = true));
        }}
        render={({
          errors,
          touched,
          handleSubmit,
          handleChange,
          values,
          setFieldValue,
          ...formikProps
        }) => (
          <React.Fragment>
            <AdminHeader {...this.props} />
            {values.loading && (
              <PopUpPortal
                HidePopup={values.loading}
                IsVisible={values.loading}
              />
            )}
            <section className="dashboard-tab user-tab pt-50 mb-50">
              <div>
                {/* <pre>Values of Formik{JSON.stringify(values, null, 2)}</pre> */}
                {/* <pre>Errors of Formik{JSON.stringify(errors, null, 2)}</pre> */}
                {/* <pre>{JSON.stringify(this.state, null, 2)}</pre> */}
                {/* <pre>{JSON.stringify(this.props,null,2)}</pre> */}
              </div>
              <Form onSubmit={handleSubmit} className="form-group">
                <div className="padding-rl-50">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="bg-box">
                          <div className="table-header">
                            <h3>
                              <div className="row">
                                <div className="col-md-8 col-sm-6 col-xs-8">
                                  <span className="left-icon">
                                    <i
                                      className="fa fa-edit"
                                      aria-hidden="true"
                                    ></i>
                                  </span>{" "}
                                  Edit Job
                                </div>
                              </div>
                            </h3>
                          </div>
                          <section
                            className="create-user page-section"
                            id="create-user"
                          >
                            <div className="row">
                              <div className=" col-md-12 col-lg-12 col-sm-12 col-xs-12 ">
                                {/* <h2 class="sub-header">Add Job </h2> */}
                                <div className="">
                                  <div className="row">
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>Job ID </label>
                                      <Field
                                        disabled
                                        type="text"
                                        name="jobId"
                                        id="jobId"
                                        value={values.jobId}
                                        autoComplete="jobId"
                                        onChange={() => {
                                          if (this.state.isEdit) {
                                            handleChange();
                                          }
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.jobId && touched.jobId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Job ID - Auto Generated"
                                      />
                                      <ErrorMessage
                                        name="jobId"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Corporate Name{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        disabled={this.state.isDisabled}
                                        as="select"
                                        name="corpId"
                                        id="corpId"
                                        value={values.corpId}
                                        placeholder="Please Select"
                                        className={
                                          "form-control" +
                                          (errors.corpId && touched.corpId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        onChange={(event) => {
                                          if (this.state.isEdit) {
                                            handleChange(event);
                                            setFieldValue(
                                              "corpId",
                                              event.target.value
                                            );
                                            setFieldValue(
                                              "corporate",
                                              event.target.selectedOptions[0]
                                                .label
                                            );
                                            this.setState({
                                              corpId: event.target.value,
                                              corporate:
                                                event.target.selectedOptions[0]
                                                  .label,
                                            });
                                            if (
                                              event.target.value !== undefined
                                            ) {
                                              StudentAssessmentService.getCorporateDetails(
                                                "corpTypeId=0" +
                                                  "&corpId=" +
                                                  event.target.value,
                                                (res) => {
                                                  if (
                                                    res.status === "success"
                                                  ) {
                                                    this.setState({
                                                      arn:
                                                        res
                                                          .responseListObject[0]
                                                          .arnIrdai,
                                                    });
                                                  }
                                                }
                                              );
                                            }
                                          }
                                        }}
                                        onBlur={(event) => {
                                          this.setState({
                                            corpId: event.target.value,
                                            corporate:
                                              event.target.selectedOptions[0]
                                                .label,
                                          });
                                        }}
                                        // onBlur={(event) => {
                                        //   console.log("cc", event);

                                        //   if (event.target.value == "") {
                                        //     this.setState({
                                        //       corporate: "",
                                        //     });
                                        //     this.setState({
                                        //       corpId: "",
                                        //     });
                                        //     setFieldValue((values.arn = ""));
                                        //     setFieldValue(
                                        //       (values.corporate = "")
                                        //     );
                                        //     setFieldValue((values.corpId = ""));
                                        //   } else {
                                        //     this.setState({
                                        //       corporate:
                                        //         event.target.selectedOptions[0]
                                        //           .label,
                                        //       corpId: event.target.value,
                                        //     });
                                        //     LoginService.TokenUser((res) => {
                                        //       localStorage.setItem(
                                        //         "jwt-token",
                                        //         res.responseObject
                                        //       );
                                        //     });
                                        //   }
                                        // }}
                                      >
                                        <option value="">--Select--</option>

                                        {(values.corporateList || []).map(
                                          (team) => (
                                            <option
                                              key={team.corpId}
                                              value={team.corpId}
                                            >
                                              {team.corpName}
                                            </option>
                                          )
                                        )}
                                      </Field>

                                      <ErrorMessage
                                        name="corpId"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>ARN / IRDAI </label>
                                      <Field
                                        type="text"
                                        name="arn"
                                        id="arn"
                                        disabled
                                        onChange={(e) => {
                                          if (this.state.isEdit) {
                                            handleChange(e);
                                          }
                                        }}
                                        onBlur={(event) => {
                                          this.setState({
                                            arn: event.target.value,
                                          });
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.arn && touched.arn
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="ARN / IRDAI"
                                      />
                                      <ErrorMessage
                                        name="arn"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>Job Posted Date </label>
                                      <Field
                                        disabled
                                        type="text"
                                        name="entryDate"
                                        id="entryDate"
                                        autoComplete="entryDate"
                                        onChange={() => {
                                          if (this.state.isEdit) {
                                            handleChange();
                                          }
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.entryDate && touched.entryDate
                                            ? " is-invalid"
                                            : "")
                                        }
                                      />
                                      <ErrorMessage
                                        name="entryDate"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Job Role
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        disabled={this.state.isDisabled}
                                        as="select"
                                        name="roleId"
                                        id="roleId"
                                        onBlur={(event) => {
                                          this.setState({
                                            roleId: event.target.value,
                                          });
                                        }}
                                        onChange={(e) => {
                                          if (this.state.isEdit) {
                                            handleChange(e);
                                          }
                                        }}
                                        // onChange={(e) => {
                                        //   if (e.target.value !== "") {
                                        //     this.setState({
                                        //       roleid: parseInt(e.target.value),
                                        //     });
                                        //   } else {
                                        //     this.setState({
                                        //       roleid: "",
                                        //     });
                                        //   }
                                        // }}
                                        className={
                                          "form-control" +
                                          (errors.roleId && touched.roleId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Job Role"
                                      >
                                        <option value="">--Select--</option>
                                        {(values.roleList || []).map((team) => (
                                          <option
                                            key={team.roleId}
                                            value={team.roleId}
                                          >
                                            {team.roleName}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="roleId"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>Job Title </label>
                                      <span className="validation"> *</span>
                                      <Field
                                        disabled={this.state.isDisabled}
                                        maxLength={50}
                                        type="text"
                                        name="jobTitle"
                                        id="jobTitle"
                                        title={values.jobTitle}
                                        onChange={(e) => {
                                          if (this.state.isEdit) {
                                            handleChange(e);
                                          }
                                        }}
                                        onBlur={(event) => {
                                          this.setState({
                                            // arn: event.target.value,
                                            jobTitle: event.target.value,
                                          });
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.jobTitle && touched.jobTitle
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Job Title"
                                      />
                                      <ErrorMessage
                                        name="jobTitle"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Associated Primary Skill{" "}
                                        <span className="validation"> *</span>
                                      </label>

                                      <Multiselect
                                        disable={this.state.isDisabled}
                                        options={this.state.skillList} // Options to display in the dropdown
                                        selectedValues={
                                          this.state.selectedPrimarySkillValue
                                        } // Preselected value to persist in dropdown
                                        onSelect={this.onPrimarySelect} // Function will trigger on select event
                                        onRemove={this.onPrimaryRemove} // Function will trigger on remove event
                                        displayValue="keySkill" // Property name to display in the dropdown options
                                        className="form-control"
                                        // selectionLimit="5"
                                        placeholder="Select Primary Skill"
                                        name="primeryskills"
                                        id="primeryskills"
                                        avoidHighlightFirstOption={true}
                                      />

                                      <ErrorMessage
                                        name="primeryskills"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>Associated Secondary Skill </label>
                                      <Multiselect
                                        disable={this.state.isDisabled}
                                        options={this.state.secondarySkillList} // Options to display in the dropdown
                                        selectedValues={
                                          this.state.selectedSecondarySkillValue
                                        } // Preselected value to persist in dropdown
                                        onSelect={this.onSecondarySelect} // Function will trigger on select event
                                        onRemove={this.onSecondaryRemove} // Function will trigger on remove event
                                        displayValue="keySkill" // Property name to display in the dropdown options
                                        className="form-control"
                                        // selectionLimit="5"
                                        placeholder="Select Secondary Skill"
                                        name="seconderyskills"
                                        id="seconderyskills"
                                        ref={this.multiselectRefPrimarySkill}
                                        avoidHighlightFirstOption={true}
                                      />
                                      <ErrorMessage
                                        name="seconderyskills"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Job Description{" "}
                                        {/* <span className="validation"> *</span> */}
                                      </label>
                                      <Field
                                        disabled={this.state.isDisabled}
                                        maxLength={255}
                                        component="textarea"
                                        type="text"
                                        rows="1"
                                        name="jobDesc"
                                        id="jobDesc"
                                        title={values.jobDesc}
                                        onChange={(e) => {
                                          if (this.state.isEdit) {
                                            handleChange(e);
                                          }
                                        }}
                                        onBlur={(event) => {
                                          this.setState({
                                            jobDesc: event.target.value,
                                          });
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.jobDesc && touched.jobDesc
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Job Description"
                                      />
                                      {/* <ErrorMessage
                                        name="jobDesc"
                                        className="validation"
                                        component="div"
                                      /> */}
                                    </div>
                                  </div>

                                  <div className="row">
                                    {/* <div class="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        CTC (LPA){" "}
                                      </label>
                                      <Field
                                        disabled={this.state.isDisabled}
                                        // type="number"
                                        type="text"
                                        maxLength={12}
                                        name="ctc"
                                        id="ctc"
                                        autoComplete="ctc"
                                        onChange={(e) => {
                                          if (this.state.isEdit) {
                                            handleChange(e);
                                          }
                                        }}
                                        onBlur={(event) => {
                                          this.setState({
                                            ctc: event.target.value,
                                          });
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.ctc && touched.ctc
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="CTC"
                                      />
                                      <ErrorMessage
                                        name="ctc"
                                        className="validation"
                                        component="div"
                                      />
                                    </div> */}

                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>CTC (LPA) </label>
                                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                      <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6 pl pr">
                                      <Field
                                        type="text"
                                        disabled={this.state.isDisabled}
                                        maxLength={12}
                                        name="ctc"
                                        id="ctc"
                                        autoComplete="ctc"
                                        onChange={(e) => {
                                            if (this.state.isEdit) {
                                              handleChange(e);
                                            }
                                          }}
                                        onBlur={(event) => {
                                          this.setState({
                                            ctc: event.target.value,
                                          });
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.ctc && touched.ctc
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="From CTC"
                                      />
                                      <ErrorMessage
                                        name="ctc"
                                        className="validation"
                                        component="div"
                                      />
                                      </div>
                                      <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6 pl pr">
                                      <Field
                                        type="text"
                                        disabled={this.state.isDisabled}
                                        maxLength={12}
                                        name="toctc"
                                        id="toctc"
                                        autoComplete="toctc"
                                        onChange={(e) => {
                                            if (this.state.isEdit) {
                                              handleChange(e);
                                            }
                                          }}
                                        onBlur={(event) => {
                                          this.setState({
                                            toctc: event.target.value,
                                          });
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.toctc && touched.toctc
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="To CTC"
                                      />
                                      <ErrorMessage
                                        name="toctc"
                                        className="validation"
                                        component="div"
                                      />
                                      </div>
                                      </div>
                                    </div>

                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Benefits{" "}
                                        {/* <span className="validation"> *</span> */}
                                      </label>
                                      <Field
                                        disabled={this.state.isDisabled}
                                        maxLength={100}
                                        component="textarea"
                                        type="text"
                                        rows="1"
                                        name="benefit"
                                        id="benefit"
                                        title={values.benefit}
                                        onChange={(e) => {
                                          if (this.state.isEdit) {
                                            handleChange(e);
                                          }
                                        }}
                                        onBlur={(event) => {
                                          this.setState({
                                            benefit: event.target.value,
                                          });
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.benefit && touched.benefit
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Benefits"
                                      />
                                      <ErrorMessage
                                        name="benefit"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Job Type{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        disabled={this.state.isDisabled}
                                        as="select"
                                        type="text"
                                        name="jobType"
                                        id="jobType"
                                        onChange={(e) => {
                                          if (this.state.isEdit) {
                                            handleChange(e);
                                          }
                                        }}
                                        onBlur={(event) => {
                                          if (event.target.value !== "") {
                                            this.setState({
                                              jobType:
                                                event.target.selectedOptions[0]
                                                  .label,
                                            });
                                          } else {
                                            this.setState({
                                              jobType: "",
                                            });
                                            setFieldValue(
                                              (values.jobType = "")
                                            );
                                          }
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.jobType && touched.jobType
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Job Type"
                                      >
                                        <option value="">--Select--</option>
                                        <option>Full Time</option>
                                        <option>Part Time</option>
                                        <option>Contract</option>
                                      </Field>
                                      <ErrorMessage
                                        name="jobType"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        State{" "}
                                        <span className="validation"> *</span>
                                      </label>

                                      <Multiselect
                                        disable={this.state.isDisabled}
                                        options={this.state.stateList} // Options to display in the dropdown
                                        selectedValues={
                                          this.state.selectedValue
                                        } // Preselected value to persist in dropdown
                                        onSelect={this.onStateSelect} // Function will trigger on select event
                                        onRemove={this.onStateRemove} // Function will trigger on remove event
                                        displayValue="stateName" // Property name to display in the dropdown options
                                        className="form-control"
                                        placeholder="Select State"
                                        name="selectedStateList"
                                        id="selectedStateList"
                                        avoidHighlightFirstOption={true}
                                      />
                                      <ErrorMessage
                                        name="selectedStateList"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        City{" "}
                                        <span className="validation"> *</span>
                                      </label>

                                      <Multiselect
                                        disable={this.state.isDisabled}
                                        options={this.state.cityList} // Options to display in the dropdown
                                        selectedValues={
                                          this.state.selectedCityValue
                                        } // Preselected value to persist in dropdown
                                        onSelect={this.onCitySelect} // Function will trigger on select event
                                        onRemove={this.onCityRemove} // Function will trigger on remove event
                                        displayValue="cityName" // Property name to display in the dropdown options
                                        className="form-control"
                                        placeholder="Select City "
                                        name="selectedCityList"
                                        id="selectedCityList"
                                        ref={this.multiselectRef}
                                        avoidHighlightFirstOption={true}
                                      />
                                      <ErrorMessage
                                        name="selectedCityList"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Suburb{" "}
                                        {/* <span className="validation"> *</span> */}
                                      </label>
                                      <Multiselect
                                        disable={this.state.isDisabled}
                                        options={this.state.suburbList} // Options to display in the dropdown
                                        selectedValues={
                                          this.state.selectedSuburbValue
                                        } // Preselected value to persist in dropdown
                                        onSelect={this.onSuburbSelect} // Function will trigger on select event
                                        onRemove={this.onSuburbRemove} // Function will trigger on remove event
                                        displayValue="suburbName" // Property name to display in the dropdown options
                                        className="form-control"
                                        placeholder="Select"
                                        // className={
                                        //   "form-control" +
                                        //   (errors.skill && touched.skill
                                        //     ? " is-invalid"
                                        //     : "")
                                        // }
                                        name="suburb"
                                        id="suburb"
                                        ref={this.multiselectRefCity}
                                        avoidHighlightFirstOption={true}
                                      />
                                      <ErrorMessage
                                        name="suburb"
                                        component="div"
                                        className="validation"
                                      />
                                      <div></div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Expiry Date
                                        <span className="validation"> *</span>
                                      </label>

                                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                        <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pl pr">
                                          <Field
                                            // disabled={this.state.isDisabled}
                                            as="select"
                                            name="expiryDay"
                                            id="expiryDay"
                                            //disabled={values.expiry ? true : false}
                                            // value={values.expiryDay}
                                            onBlur={(event) => {
                                              this.setState({
                                                expiryDay: event.target.value,
                                              });
                                            }}
                                            onChange={(e) => {
                                              // if (this.state.isEdit) {
                                                handleChange(e);
                                                var listOfMonth = [];
                                                // if (e.target.value === 31) {
                                                  if ([31,"31"].includes(e.target.value)) {
                                                  listOfMonth = [
                                                    { key: 1, value: "Jan" },
                                                    { key: 3, value: "Mar" },
                                                    { key: 5, value: "May" },
                                                    { key: 7, value: "Jul" },
                                                    { key: 8, value: "Aug" },
                                                    { key: 10, value: "Oct" },
                                                    { key: 12, value: "Dec" },
                                                  ];
                                                } else if (
                                                  // e.target.value === 30
                                                  [30,"30"].includes(e.target.value)
                                                ) {
                                                  listOfMonth = [
                                                    { key: 1, value: "Jan" },
                                                    { key: 3, value: "Mar" },
                                                    { key: 4, value: "Apr" },
                                                    { key: 5, value: "May" },
                                                    { key: 6, value: "Jun" },
                                                    { key: 7, value: "Jul" },
                                                    { key: 8, value: "Aug" },
                                                    { key: 9, value: "Sep" },
                                                    { key: 10, value: "Oct" },
                                                    { key: 11, value: "Nov" },
                                                    { key: 12, value: "Dec" },
                                                  ];
                                                } else if (
                                                  // e.target.value === 28 ||
                                                  // e.target.value === 29
                                                  [28,"28",29,"29"].includes(e.target.value)
                                                ) {
                                                  listOfMonth = [
                                                    { key: 1, value: "Jan" },
                                                    { key: 2, value: "Feb" },
                                                    { key: 3, value: "Mar" },
                                                    { key: 4, value: "Apr" },
                                                    { key: 5, value: "May" },
                                                    { key: 6, value: "Jun" },
                                                    { key: 7, value: "Jul" },
                                                    { key: 8, value: "Aug" },
                                                    { key: 9, value: "Sep" },
                                                    { key: 10, value: "Oct" },
                                                    { key: 11, value: "Nov" },
                                                    { key: 12, value: "Dec" },
                                                  ];
                                                } else {
                                                  listOfMonth = [
                                                    { key: 1, value: "Jan" },
                                                    { key: 2, value: "Feb" },
                                                    { key: 3, value: "Mar" },
                                                    { key: 4, value: "Apr" },
                                                    { key: 5, value: "May" },
                                                    { key: 6, value: "Jun" },
                                                    { key: 7, value: "Jul" },
                                                    { key: 8, value: "Aug" },
                                                    { key: 9, value: "Sep" },
                                                    { key: 10, value: "Oct" },
                                                    { key: 11, value: "Nov" },
                                                    { key: 12, value: "Dec" },
                                                  ];
                                                }
                                                setFieldValue(
                                                  (values.listOfExpiryMonth = listOfMonth)
                                                );
                                              // }
                                            }}
                                            // onChange={(e) => {
                                            //   ////debugger;

                                            //   console.log(
                                            //     "event",
                                            //     e.target.value
                                            //   );

                                            // var listOfMonth = [];
                                            // setFieldValue(
                                            //   (values.expiryDay =
                                            //     e.target.value)
                                            // );
                                            // this.setState({
                                            //   expiryDay: e.target.value,
                                            // });
                                            // if (e.target.value == 31) {
                                            //   listOfMonth = [
                                            //     { key: 1, value: "Jan" },
                                            //     { key: 3, value: "Mar" },
                                            //     { key: 5, value: "May" },
                                            //     { key: 7, value: "Jul" },
                                            //     { key: 8, value: "Aug" },
                                            //     { key: 10, value: "Oct" },
                                            //     { key: 12, value: "Dec" },
                                            //   ];
                                            // } else if (e.target.value == 30) {
                                            //   listOfMonth = [
                                            //     { key: 1, value: "Jan" },
                                            //     { key: 3, value: "Mar" },
                                            //     { key: 4, value: "Apr" },
                                            //     { key: 5, value: "May" },
                                            //     { key: 6, value: "Jun" },
                                            //     { key: 7, value: "Jul" },
                                            //     { key: 8, value: "Aug" },
                                            //     { key: 9, value: "Sep" },
                                            //     { key: 10, value: "Oct" },
                                            //     { key: 11, value: "Nov" },
                                            //     { key: 12, value: "Dec" },
                                            //   ];
                                            // } else if (
                                            //   e.target.value == 28 ||
                                            //   e.target.value == 29
                                            // ) {
                                            //   listOfMonth = [
                                            //     { key: 1, value: "Jan" },
                                            //     { key: 2, value: "Feb" },
                                            //     { key: 3, value: "Mar" },
                                            //     { key: 4, value: "Apr" },
                                            //     { key: 5, value: "May" },
                                            //     { key: 6, value: "Jun" },
                                            //     { key: 7, value: "Jul" },
                                            //     { key: 8, value: "Aug" },
                                            //     { key: 9, value: "Sep" },
                                            //     { key: 10, value: "Oct" },
                                            //     { key: 11, value: "Nov" },
                                            //     { key: 12, value: "Dec" },
                                            //   ];
                                            // } else {
                                            //   listOfMonth = [
                                            //     { key: 1, value: "Jan" },
                                            //     { key: 2, value: "Feb" },
                                            //     { key: 3, value: "Mar" },
                                            //     { key: 4, value: "Apr" },
                                            //     { key: 5, value: "May" },
                                            //     { key: 6, value: "Jun" },
                                            //     { key: 7, value: "Jul" },
                                            //     { key: 8, value: "Aug" },
                                            //     { key: 9, value: "Sep" },
                                            //     { key: 10, value: "Oct" },
                                            //     { key: 11, value: "Nov" },
                                            //     { key: 12, value: "Dec" },
                                            //   ];
                                            // }
                                            // setFieldValue(
                                            //   (values.listOfExpiryMonth = listOfMonth)
                                            // );
                                            // }}
                                            className={
                                              "form-control" +
                                              (errors.expiryDay &&
                                              touched.expiryDay
                                                ? " is-invalid"
                                                : "")
                                            }
                                          >
                                            <option value="">DD</option>
                                            {(values.listOfExpiryDay || []).map(
                                              (d) => (
                                                <option value={d}>{d}</option>
                                              )
                                            )}
                                          </Field>
                                          <ErrorMessage
                                            name="expiryDay"
                                            className="validation"
                                            component="div"
                                          />
                                        </div>
                                        <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                          <Field
                                            // disabled={this.state.isDisabled}
                                            as="select"
                                            name="expirymonth"
                                            id="expirymonth"
                                            //disabled={values.expirymonth ? true : false}
                                            onBlur={(event) => {
                                              this.setState({
                                                expirymonth: event.target.value,
                                              });
                                            }}
                                            onChange={(e) => {
                                              // if (this.state.isEdit) {
                                                handleChange(e);

                                                var listOfDay = [];

                                                // if (e.target.value === 2) {
                                                  if ([2,"2"].includes(e.target.value)) {
                                                  listOfDay = [];
                                                  for (
                                                    var i = 1;
                                                    i <= 29;
                                                    i++
                                                  ) {
                                                    listOfDay.push(i);
                                                  }
                                                } else if (
                                                  // e.target.value === 1 ||
                                                  // e.target.value === 3 ||
                                                  // e.target.value === 5 ||
                                                  // e.target.value === 7 ||
                                                  // e.target.value === 8 ||
                                                  // e.target.value === 10 ||
                                                  // e.target.value === 12
                                                  [1,"1",3,"3",5,"5",7,"7",8,"8",10,"10",12,"12"].includes(e.target.value)
                                                ) {
                                                  listOfDay = [];
                                                  for (
                                                    var iod = 1;
                                                    iod <= 31;
                                                    iod++
                                                  ) {
                                                    listOfDay.push(iod);
                                                  }
                                                } else {
                                                  listOfDay = [];
                                                  for (
                                                    var iol = 1;
                                                    iol <= 30;
                                                    iol++
                                                  ) {
                                                    listOfDay.push(iol);
                                                  }
                                                }
                                                setFieldValue(
                                                  (values.listOfExpiryDay = listOfDay)
                                                );
                                              // }
                                            }}
                                            // onChange={(e) => {
                                            //   ////debugger
                                            //   var listOfDay = [];
                                            //   setFieldValue(
                                            //     (values.expirymonth =
                                            //       e.target.value)
                                            //   );
                                            //   this.setState({
                                            //     expirymonth: e.target.value,
                                            //   });
                                            //   if (e.target.value == 2) {
                                            //     listOfDay = [];
                                            //     for (var i = 1; i <= 29; i++) {
                                            //       listOfDay.push(i);
                                            //     }
                                            //   } else if (
                                            //     e.target.value == 1 ||
                                            //     e.target.value == 3 ||
                                            //     e.target.value == 5 ||
                                            //     e.target.value == 7 ||
                                            //     e.target.value == 8 ||
                                            //     e.target.value == 10 ||
                                            //     e.target.value == 12
                                            //   ) {
                                            //     listOfDay = [];
                                            //     for (
                                            //       var iod = 1;
                                            //       iod <= 31;
                                            //       iod++
                                            //     ) {
                                            //       listOfDay.push(iod);
                                            //     }
                                            //   } else {
                                            //     listOfDay = [];
                                            //     for (
                                            //       var iol = 1;
                                            //       iol <= 30;
                                            //       iol++
                                            //     ) {
                                            //       listOfDay.push(iol);
                                            //     }
                                            //   }
                                            //   setFieldValue(
                                            //     (values.listOfExpiryDay = listOfDay)
                                            //   );
                                            // }}
                                            className={
                                              "form-control" +
                                              (errors.expirymonth &&
                                              touched.expirymonth
                                                ? " is-invalid"
                                                : "")
                                            }
                                          >
                                            <option value="">MM</option>
                                            {(
                                              values.listOfExpiryMonth || []
                                            ).map((m) => (
                                              <option value={m.key}>
                                                {m.value}
                                              </option>
                                            ))}
                                          </Field>
                                          <ErrorMessage
                                            name="expirymonth"
                                            className="validation"
                                            component="div"
                                          />
                                        </div>
                                        <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                                          <Field
                                            // disabled={this.state.isDisabled}
                                            as="select"
                                            name="expiryYear"
                                            id="expiryYear"
                                            className={
                                              "form-control" +
                                              (errors.expiryYear &&
                                              touched.expiryYear
                                                ? " is-invalid"
                                                : "")
                                            }
                                            onChange={(e) => {
                                              // if (this.state.isEdit) {
                                                handleChange(e);
                                              // }
                                            }}
                                            onBlur={(e) => {
                                              ////debugger
                                              setFieldValue(
                                                (values.expiryYear =
                                                  e.target.value)
                                              );
                                              this.setState({
                                                expiryYear: e.target.value,
                                              });
                                            }}
                                          >
                                            <option value="">YYYY</option>
                                            {(
                                              this.state.listOfExpiryYear || []
                                            ).map((year) => (
                                              <option value={year}>
                                                {year}
                                              </option>
                                            ))}
                                          </Field>
                                          <ErrorMessage
                                            name="expiryYear"
                                            className="validation"
                                            component="div"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <div>
                                        <label>Total Score </label>
                                        <Field
                                          name="totalScore"
                                          placeholder="Total Score"
                                          type="number"
                                          disabled
                                          className="form-control"
                                          value={values.totalScore}
                                          onChange={() => {
                                            if (this.state.isEdit) {
                                              handleChange();
                                            }
                                          }}
                                        />
                                        <ErrorMessage
                                          name="totalScore"
                                          className="validation"
                                          component="div"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Minimum Eligible Score{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        disabled={this.state.isDisabled}
                                        name="eligibleScore"
                                        placeholder="Minimum Eligible Score"
                                        // type="number"
                                        type="text"
                                        className="form-control"
                                        value={values.eligibleScore}
                                        // onChange={handleChange}
                                        onBlur={(event) => {
                                          this.setState({
                                            eligibleScore: event.target.value,
                                          });
                                        }}
                                        onChange={(e) => {
                                          if (this.state.isEdit) {
                                            handleChange(e);
                                            setFieldValue(
                                              "eligibleScore",
                                              e.target.value
                                            );
                                            this.setState({
                                              eligibleScore: e.target.value,
                                            });
                                          }
                                        }}
                                      />
                                      <ErrorMessage
                                        name="eligibleScore"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Status{" "}
                                        <span className="validation"> *</span>{" "}
                                      </label>
                                      <Field
                                        as="select"
                                        name="isActive"
                                        id="isActive"
                                        // onChange={handleChange}
                                        onChange={(event)=>
                                          this.setState({
                                            isActive: event.target.value,
                                          })
                                        }
                                        // onChange={(e) => {
                                        //   if (this.state.isEdit) {
                                        //     handleChange(e);
                                        //   }
                                        // }}
                                        value={values.isActive}
                                        onBlur={(event) => {
                                          this.setState({
                                            isActive: event.target.value,
                                          });
                                        }}
                                        title={
                                          values.isActive === "0"
                                            ? "InActive"
                                            : values.isActive === "1"
                                            ? "Active"
                                            : "Draft"
                                        }
                                        className={
                                          "form-control" +
                                          (errors.isActive && touched.isActive
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="">-- Select --</option>
                                        {!["Draft"].includes(this.props.location?.state?.jobStatus) && <option value="0">InActive</option>}
                                        <option value="1">Active</option>
                                        {!["Active","Inactive"].includes(this.props.location?.state?.jobStatus) && <option value="2">Draft</option>}
                                        {/* {this.props.location.state
                                          .applicantCount <= 0 ? (
                                          // .applicantCount > 0 ? (
                                          <option value="2">Draft</option>
                                        ) : (
                                          ""
                                        )} */}
                                      </Field>
                                      <ErrorMessage
                                        name="isActive"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Job Category{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        disabled={this.state.isDisabled}
                                        as="select"
                                        type="text"
                                        name="jobCategory"
                                        id="jobCategory"
                                        // onChange={handleChange}
                                        onChange={(e) => {
                                          if (this.state.isEdit) {
                                            handleChange(e);
                                            setFieldValue(
                                              "jobCategory",
                                              e.target.value
                                            );
                                            this.setState({
                                              jobCategory: e.target.value,
                                            });
                                          }
                                        }}
                                        onBlur={(event) => {
                                          this.setState({
                                            jobCategory: event.target.value,
                                          });
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.jobCategory && touched.jobCategory
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Job Category"
                                      >
                                        <option value="">--Select--</option>
                                        {(values.jobCategoryList || []).map(
                                          (job) => (
                                            <option
                                              key={job.jobCategoryID}
                                              value={job.jobCategoryID}
                                            >
                                              {job.jobCategoryName}
                                            </option>
                                          )
                                        )}
                                      </Field>
                                      <ErrorMessage
                                        name="jobCategory"
                                        className="validation"
                                        component="div"
                                      />
                                  </div>
                                  {/* <div class="col-md-4 col-sm-4 col-xs-12">
                                      <label>Experience{" "}
                                        <span className="validation"> *</span> </label>
                                      <Field
                                        type="text"
                                        disabled={this.state.isDisabled}
                                        maxLength={10}
                                        name="experience"
                                        id="experience"
                                        autoComplete="experience"
                                        onChange={(e) => {
                                          if (this.state.isEdit) {
                                            handleChange(e);
                                            setFieldValue(
                                              "experience",
                                              e.target.value
                                            );
                                            this.setState({
                                              experience: e.target.value,
                                            });
                                          }
                                        }}
                                        onBlur={(event) => {
                                          this.setState({
                                            experience: event.target.value,
                                          });
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.experience && touched.experience
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Experience"
                                      />
                                      <ErrorMessage
                                        name="experience"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                            */}

                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                             Experience
                                            <span className="validation">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <Field
                                            disabled={this.state.isDisabled}
                                            as="select"
                                            name="experience"
                                            id="experience"
                                            className="form-control "
                                            // onChange={handleChange}
                                            onChange={(e) => {
                                              if (this.state.isEdit) {
                                                handleChange(e);
                                                setFieldValue(
                                                  "experience",
                                                  e.target.value
                                                );
                                                this.setState({
                                                  experience: e.target.value,
                                                });
                                              }
                                            }}
                                            onBlur={(event) => {
                                              this.setState({
                                                experience: event.target.value,
                                              });
                                            }}
                                            style={{ border: "1px solid #fbc583" }}
                                            value={values.experience}
                                          >
                                            <option value="">--SELECT--</option>
                                            {(values.totalExperienceList || []).map(
                                              (item) => (
                                                <option
                                                  key={item.experienceID}
                                                  value={item.experienceID}
                                                >
                                                  {item.experienceName}
                                                </option>
                                              )
                                            )}
                                          </Field>
                                        <ErrorMessage
                                        name="experience"
                                        className="validation "
                                        component="div"
                                      />
                                        </div>
                                 
                                  </div>
                                </div>
                              </div>
                              <br />
                              <br />
                            </div>
                          </section>
                          <AdminEditQuestionnaire
                            {...this.props}
                            parentCallback={this.handleCallback}
                            questionnaireDataProp={this.state.questionnaireData}
                            isDisabled={this.state.isDisabled}
                            isEdit={this.state.isEdit}
                          />

                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-20">
                            <a href>
                              <button
                                type="submit"
                                name="submit"
                                className="btn-4 pull-right"
                                onSubmit={async () => {
                                  const curErrors = await formikProps.validateForm();
                                  const curErrorsKeys = Object.keys(curErrors);

                                  if (curErrorsKeys.length) {
                                    const el = document.getElementById(
                                      curErrorsKeys[0]
                                    );

                                    if (el) el.focus();
                                  }
                                }}
                              >
                                Update
                              </button>
                            </a>
                            <a href>
                              <button
                                type="reset"
                                className="btn-4 mr-20 pull-right"
                                onClick={this.reset}
                              >
                                Cancel
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </section>
            <Finxfooter />
          </React.Fragment>
        )}
      />
    );
  }
}

export default adminEditJob;
